import { modals } from './../helpers';
import {
  getModalInfoByOwner,
  getFullPath
} from './../reducers';
import { push } from 'react-router-redux';

export const SET_MODAL_INFO = 'SET_MODAL_INFO';
export const setModalInfo = (visible, owner, info) => ({
  type: 'SET_MODAL_INFO',
  visible,
  owner,
  info
});

/**
 * Sets state for the AddComment modal
 * @param {bool} visible - whether or not the modal should be visible
 * @param {any} item - the item (job, build, scenario) that the comment is concerning
 * @param {int} position - used in jira history generation to link user to
 *  dashboard with appropriate scenario expanded
 */
export const showAddComment = (visible, item, dispatcherId, dispatcherType, position) =>
  (dispatch) => {
    return dispatch(setModalInfo(
      visible,
      modals.owners.comment,
      { item, dispatcherId, dispatcherType, position }
    ));
  };

/**
 * Sets state for the CommentHistory modal
 * @param {*} visible - whether or not the modal should be visible
 * @param {*} item - the item (job, build, scenario) that history is concerning
 */
export const showCommentHistory = (visible, item, dispatcherId) => (dispatch) => {
  return dispatch(setModalInfo(
    visible,
    modals.owners.commentHistory,
    { item, dispatcherId }
  ));
};

export const showScenarioModal = (visible, dispatcherId) =>
  (dispatch) => {
    return dispatch(setModalInfo(
      visible,
      modals.owners.scenarioStatus,
      { dispatcherId }
    ));
  };

export const showArtifactHitCountModal = (visible, metric, isCcf) => (dispatch) => {
  return dispatch(setModalInfo(
    visible,
    modals.owners.artifactHitCount,
    { metric, isCcf }
  ));
};

export const showJiraLoginModal = (visible, redirectFunc) => (dispatch) => {
  return dispatch(setModalInfo(
    visible,
    modals.owners.jiraLogin,
    { redirectFunc }
  ));
};

export const showHistory = (visible, scenarioName) => (dispatch) => {
  return dispatch(setModalInfo(
    visible,
    modals.owners.scenarioHistory,
    { scenarioName }
  ));
};

export const showChangeCommenterName = (visible, scenarioId, status, position) =>
  (dispatch) => {
    return dispatch(setModalInfo(
      visible,
      modals.owners.changeCommenterName,
      { scenarioId, status, position }
    ));
  };

export const showTestsExpectedModal = (visible) => (dispatch) => {
  return dispatch(setModalInfo(
    visible,
    modals.owners.testsExpected
  ));
};

export const showTestsScenariosModal = (visible, runners) => (dispatch) => {
  return dispatch(setModalInfo(
    visible,
    modals.owners.installerTestsScenarios,
    { runners }
  ));
};

export const showTestArtifactsModal = (visible, runner) => (dispatch) => {
  return dispatch(setModalInfo(
    visible,
    modals.owners.testArtifacts,
    { runner }
  ));
};

export const showCaseAmendingBaselineUpdateModal = (visible, title) =>
  (dispatch) => {
    return dispatch(setModalInfo(
      visible,
      modals.owners.caseAmendingBaseline,
      { imageName: title }
    ));
  };

export const showBuildSelectorModal = (visible, isBaseline) => (dispatch) => {
  return dispatch(setModalInfo(
    visible,
    modals.owners.buildsBaseline,
    { isBaseline }
  ));
};

export const showAcknowledgeBaselineUpdateModal = (visible, scenario, title) =>
  (dispatch) => {
    return dispatch(setModalInfo(
      visible,
      modals.owners.acknowledgeBaselineUpdate,
      { scenario, title }
    ));
  };
export const showStatisticsModal = (visible) => (dispatch) => {
  return dispatch(setModalInfo(visible, modals.owners.statistics));
};

export const showRetriggerScenariosModal = (visible) => (dispatch) => {
  return dispatch(setModalInfo(visible, modals.owners.retriggerScenarios));
};

export const showSetMetricsByDateModal = (visible) => (dispatch) => {
  return dispatch(setModalInfo(visible, modals.owners.metricsByDate));
};

export const showAcknowledgeTestsModal = (visible) => (dispatch) => {
  return dispatch(setModalInfo(visible, modals.owners.acknowledgeTests));
};

export const showVerifyArtifactApplicationModal = (visible, applicationInfo) =>
  (dispatch) => {
    return dispatch(setModalInfo(
      visible,
      modals.owners.verifyArtifactApplication,
      { ...applicationInfo }));
  };

export const showJiraConfirmModal =
(visible, scanKeys, typesChecked, artifact = '', delta = undefined) =>
  (dispatch) => {
    return dispatch(setModalInfo(
      visible,
      modals.owners.jiraConfirm,
      { scanKeys, typesChecked, artifact, delta }
    ));
  };

export const setScenarioModalInProgressOnly = (inProgressOnly) => (dispatch) => {
  return dispatch(setModalInfo(
    true,
    modals.owners.scenarioStatus,
    { inProgressOnly }
  ));
};

export const setArtifactHitCountModalDiffOnly = (diffOnly) => (dispatch) => {
  return dispatch(setModalInfo(
    true,
    modals.owners.artifactHitCount,
    { diffOnly }
  ));
};


export const setHistoryInfo = (startDate, scenarioName, runsToShow, buildType) =>
  (dispatch) => {
    return dispatch(setModalInfo(
      true,
      modals.owners.scenarioHistory,
      { startDate, scenarioName, runsToShow, buildType }
    ));
  };

export const toggleHistoryDetails = () => (dispatch, getState) => {
  const info = getModalInfoByOwner(getState(), modals.owners.scenarioHistory);
  return dispatch(setModalInfo(
    true,
    modals.owners.scenarioHistory,
    { details: !info.details }
  ));
};

export const toggleTestArtifactsDetails = (detailsVisible) => (dispatch) => {
  return dispatch(setModalInfo(
    true,
    modals.owners.testArtifacts,
    { detailsVisible }
  ));
};

export const goToScenario = (scenarioPosition) => (dispatch, getState) => {
  dispatch(setModalInfo(
    false,
    modals.owners.installerTestsScenarios,
  ));
  const state = getState();
  const fullPath = getFullPath(state);
  if (fullPath.indexOf('&ex=') === -1)
    dispatch(push(fullPath + '&ex=' + scenarioPosition));
  else
  {
    const modPath = fullPath.substring(0, fullPath.indexOf('&ex=')) +
      '&ex=' + scenarioPosition;
    dispatch(push(modPath));
  }
  const element = document.getElementById('scenario-list-container');
  element.scrollIntoView();
};

export const setJiraConfirmCheckedTypes = (typesChecked) => (dispatch) => {
  return dispatch(setModalInfo(
    true,
    modals.owners.jiraConfirm,
    { typesChecked }
  ));
};

export const setJiraConfirmDialogIssue = (issue) => (dispatch) => {
  return dispatch(setModalInfo(
    true,
    modals.owners.jiraConfirm,
    { issue }
  ));
};

export const setShowCommentsModalTicketsOnly = (ticketsOnly) => (dispatch) => {
  return dispatch(setModalInfo(
    true,
    modals.owners.commentHistory,
    { ticketsOnly }
  ));
};

export const setBaselineUpdateRetriggerOption = (retrigger) => (dispatch) => {
  return dispatch(setModalInfo(
    true,
    modals.owners.acknowledgeBaselineUpdate,
    { retrigger }
  ));
};


// WEBPACK FOOTER //
// src/actions/modal.js